import { commonTypes } from './types';

const setLoading = (payload: boolean) => ({
  type: commonTypes.SET_LOADING,
  payload,
});

const setSubmitting = (payload: boolean) => ({
  type: commonTypes.SET_SUBMITTING,
  payload,
});

const setSidebar = (payload: boolean) => ({
  type: commonTypes.SET_SIDEBAR,
  payload,
});
const setCollapseSidebar = (payload: boolean) => ({
  type: commonTypes.SET_COLLAPSE_SIDEBAR,
  payload,
});

export { setLoading, setSubmitting, setSidebar, setCollapseSidebar };
